//
// This is file for the temporary dummy agenda dashboard, which exists just for us developers
// to check the current normalizded event data. We should not build on this.
// So it's not build to our usual standards (is very far off even), so ignore any ugly, hacky and
// unused code.
//

import { ifAuthenticated, loginAuthenticate } from '../../router/routing_helpers';

export default [
  {
    path: '/agenda-debug',
    name: 'agendaDebugDashboard',
    beforeEnter: loginAuthenticate,
    component: () => import(/* webpackChunkName: "AgendaOverview" */ './views/AgendaDebugOverview.vue'),
  },
  {
    path: '/agenda-debug/:agendaId',
    name: 'agenda-debug-detail',
    beforeEnter: ifAuthenticated,
    // Lazy loading agenda
    component: () => import(/* webpackChunkName: "AgendaDetail" */ './views/AgendaDebugDetail.vue'),
  },
];
